<template>
	<div class="row justify-content-center align-content-center vh-80 vw-100">
		<b>REDIRECIONANDO...</b>
		<div
			class="modal fade"
			id="select-stamp"
			tabindex="-1"
			data-backdrop="static"
			aria-labelledby="select-stamp-title"
			@keyup.esc="RedirectToHome"
		>
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-body">
						<div class="p-4 p-md-5">
							<div class="mb-4 text-center">
								<h2
									id="select-stamp-title"
									class="font-32"
								>
									Selecione um carimbo
								</h2>
							</div>
							<form class="row justify-content-between">
								<div class="col-12">
									<div
										v-for="(stamp, index) in stamps"
										:key="index"
										class="select-card with-border mt-2"
									>
										<label
											for="card-checkbox"
											class="pr-55 text-uppercase text-overflow"
											@click="Select(stamp)"
										>
											{{
												stamp.professional_advice_description
											}}: {{ stamp.number }} -
											{{ stamp.uf_professional_advice }}
											<i class="far fa-chevron-right"></i>
										</label>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
		<ChangelogModal
			:notification="notification"
			@close="MarkNotificationAsRead"
		/>
	</div>
</template>

<script>
	import Session from '@/utils/sessions/Session.js'
	import Vuex from './../../vuex'
	import _, { map } from 'lodash'
	import { mapGetters, mapActions } from 'vuex'
	import Swal from 'sweetalert2'
	import ChangelogModal from './components/ChangelogModal'
	import { useError } from '@/composables'
	export default {
		name: 'Redirect',
		components: {
			ChangelogModal,
		},
		data() {
			return {
				SCHEDULE_TYPES: {
					PRE_APPOINTMENT: 1,
					URGENT_APPOINTMENT: 2,
				},
				selected: {
					stamp: null,
					route: null,
				},
				notification: {
					changelog: '',
				},
			}
		},
		computed: {
			...mapGetters('auth', [
				'account',
				'stamps',
				'requester_selected_id',
				'requester_selected_object',
				'data_migrating_organizations',
				'selected_stamp',
			]),
			...mapGetters('system', ['keep_connected']),
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			...mapActions('auth', ['GetAuthAccount']),
			Select(stamp) {
				this.selected.stamp = stamp

				window.jQuery('#select-stamp').modal('hide')

				this.Validate()
			},
			async Validate() {
				let update_template = false
				let pending_template_update = this.HasPendingTemplateUpdate(
					this.requester_selected_id
				)

				let provider = this.account

				if (pending_template_update) {
					update_template = await this.PendingTemplateQuestion(
						pending_template_update
					)
				}

				if (update_template) {
					this.StartLoading()

					let destiny_vuex = new Vuex().getters['auth/requesters']
					let wk =
						_.filter(destiny_vuex, requester => {
							if (
								requester.account_requester_id ==
								this.requester_selected_id
							) {
								return requester
							}
						})[0] ?? null

					const obj = {
						destiny: {
							account_id: wk.account_requester_id,
							schema: wk.workgroup_schema,
							provider_id: provider.id,
							type: 'WK',
							only_restore: true,
						},
						options: {
							template: true,
							schedules_and_proceedings: false,
							configurations: false,
							flow: false,
						},
						source: {
							account_id: wk.account_requester_id,
							schema: wk.instance.config.schema_name,
							type: 'PJ',
						},
						account_responsible_id: provider.id,
						organization_id: this.requester_selected_id,
					}

					await window.api
						.call('post', '/restore-from-default-template', obj)
						.then(({ data }) => {
							if (data.response) {
								Swal.fire({
									icon: 'success',
									title: 'Procedimento Concluido !',
									text: 'Template restaurado com sucesso.',
								})
							} else {
								Swal.fire({
									icon: 'error',
									text: 'Houve um erro ao concluir, contate o suporte.',
									title: 'Eita!',
								})
							}
						})
						.finally(() => {
							this.FinishLoading()
						})
				}

				if (await this.IsUpdating()) return

				if (this.HaveOrganizationSyncNotification()) return

				this.RedirectToApp()
			},
			HasPendingTemplateUpdate(organization_id) {
				let requesters = new Vuex().getters['auth/requesters']

				let requester =
					_.filter(requesters, requester => {
						if (requester.account_requester_id == organization_id) {
							return requester
						}
					})[0] ?? null

				if (requester && requester.pending_template_update)
					return requester.pending_template_update

				return null
			},
			async PendingTemplateQuestion(pending_template_update) {
				let provider = this.account

				let update_template = false

				await Swal.fire({
					icon: 'warning',
					title: 'Aviso!',
					html: `O template padrão da sua organização foi atualizado por <b>${pending_template_update.template_manager.account_responsible.name}</b> e você precisa atualizar o seu! Não será possível laudar até que você atualize-o.`,
					showCancelButton: true,
					confirmButtonText: 'Atualizar agora',
					cancelButtonText: 'Agora não',
				}).then(async result => {
					if (result.isConfirmed) {
						this.StartLoading()

						await window.api
							.call('post', '/check-pending-laudos', {
								account_provider_id: provider.id,
								account_requester_id:
									this.requester_selected_id,
							})
							.then(async ({ data }) => {
								if (data.response) {
									if (data.laudos_pendentes > 0) {
										await Swal.fire({
											icon: 'error',
											title: 'Laudos em aberto!',
											html: `Você possui <b>${data.laudos_pendentes} laudos</b> em aberto. Finalize todos para concluír a ação`,
											showConfirmButton: true,
											preConfirm: () => {
												const APP_URL =
													process.env.VUE_APP_APP_URL

												window.location.href = `${APP_URL}/consultar_laudos?templateUpdate=true`
											},
										})

										return
									}

									update_template = true
								} else {
									Swal.fire({
										icon: 'error',
										title: 'Eita!',
										text: 'Houve um erro ao concluir, contate o suporte.',
										showConfirmButton: true,
										preConfirm: () => {
											this.$router.push({ name: 'Home' })
										},
									})
								}
							})
							.finally(() => {
								this.FinishLoading()
							})
					}
				})

				return update_template
			},
			async IsUpdating() {
				const data_migrating_organizations = [
					...this.data_migrating_organizations,
				]

				if (
					data_migrating_organizations.length > 0 &&
					data_migrating_organizations.indexOf(
						parseInt(this.requester_selected_id)
					) > -1
				) {
					Swal.fire({
						icon: 'warning',
						title: 'Aviso!',
						text: 'No momento está sendo feita uma atualização nos dados da sua Organização, aguarde alguns minutos e tente novamente...',
					})

					this.$router.push({ name: 'Home' })

					await this.GetAuthAccount()

					return true
				}

				return false
			},
			HaveOrganizationSyncNotification() {
				if (!this.requester_selected_object?.notification) return false

				const notification = this.requester_selected_object.notification

				if (notification.read) return false

				this.notification = notification

				window.jQuery('#changelog-modal').modal('show')

				return true
			},
			MarkNotificationAsRead() {
				return window.api
					.call('post', '/mark-notification-as-read', {
						...this.notification,
					})
					.then(({ data }) => {
						if (data.response) {
							this.RedirectToApp()
						}
					})
			},
			async RedirectToApp() {
				this.StartLoading()

				const APP_URL = process.env.VUE_APP_APP_URL

				const session_data = await this.HandleSession()

				return window.api
					.call('post', '/redirect-to-app', {
						...this.selected,
						account_id: this.requester_selected_id,
						keep_connected: this.keep_connected,
						session_data,
						schedule_type: this.schedule_type,
					})
					.then(({ data }) => {
						if (data.response) {
							window.location.href = `${APP_URL}/auth/login/${data.bridge_key}`
						} else {
							Swal.fire({
								icon: 'error',
								title: 'Eita!',
								text: 'Houve um erro ao concluir, contate o suporte.',
								showConfirmButton: true,
								preConfirm: () => {
									this.$router.push({ name: 'Home' })
								},
							})
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			async HandleSession() {
				if (!window.Session) {
					window.Session = new Session()
					await window.Session.Init()
				}

				return window.Session.GetSessionData()
			},
			HasStamps() {
				return this.stamps.length > 0
			},
			NoHaveAnyStamp() {
				useError('VOCÊ PRECISA CADASTRAR UM CARIMBO PARA CONTINUAR.')
					.then(() => {
						this.RedirectToHome()
					})
			},
			RedirectToHome(event) {
				event?.target.blur()

				this.$router.push({ name: 'Home' })
			},
		},
		mounted() {
			if (!this.requester_selected_id) {
				this.$route.push({ name: 'Home' })
			}

			const meta = this.$route.meta

			this.selected.route = meta.appRouteName

			const routePath = this.$route.path

			if (routePath.includes('/pronto-atendimento')) {
				this.schedule_type = this.SCHEDULE_TYPES.URGENT_APPOINTMENT
			} else if (routePath.includes('/atendimento-agendado')) {
				this.schedule_type = this.SCHEDULE_TYPES.PRE_APPOINTMENT
			}

			if (this.HasStamps()) {
				if (this.selected_stamp) {
					this.selected.stamp = this.selected_stamp

					if (this.HaveOrganizationSyncNotification()) return

					this.RedirectToApp()

					return
				} else {
					window.jQuery('#select-stamp').modal('show')
				}
			} else {
				this.NoHaveAnyStamp()
			}
		},
	}
</script>

<style lang="css" scoped></style>
